import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export function SliderLayout(props = {}, childrenComponents = []) {
	return {
		componentName: 'SliderLayout',
		componentId: uuidv4(),
		props: _.merge(
			{
				label: 'slider',
				itemsPerPage: {
					desktop: 1,
					tablet: 1,
					phone: 1,
				},
				centerMode: {
					desktop: 'disabled',
					tablet: 'disabled',
					phone: 'disabled',
				},
				infinite: true,
				showNavigationArrows: 'always',
				showPaginationDots: 'always',
				navigationStep: 'page',
				usePagination: true,
				arrowSize: {
					desktop: 25,
					tablet: 25,
					phone: 25,
				},
				slideTransition: {
					speed: 400,
					delay: 0,
					timing: '',
				},
				fullWidth: true,
			},
			props,
		),
		childrenComponents,
	};
}
